<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">
        智慧工地&nbsp;&nbsp;
        {{ this.$route.meta.name }} &nbsp;&nbsp;数据查询</span
      >
    </div>
    <el-main>
      <el-tabs v-model="name" tab-position="top" @tab-click="">
        <el-tab-pane label="升降机" name="a">
          <el-descriptions
            class="margin-top"
            style="width: 100%"
            :column="4"
            border
          >
            <el-descriptions-item>
              <template slot="label"> 系统时间 </template>
              <el-date-picker
                v-model="startTime"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 设备型号 </template>
              <el-select placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in [{ value: 0, label: '全部' }]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 设备状态 </template>
              <el-select placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in [{ value: 0, label: '全部' }]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 机笼 </template>
              <el-select placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in [{ value: 0, label: '全部' }]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label"> 报警类型 </template>
              <div class="flex" style="justify-content:space-between;">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox label="正常"></el-checkbox>
                  <el-checkbox label="重量"></el-checkbox>
                  <el-checkbox label="高度"></el-checkbox>
                  <el-checkbox label="速度"></el-checkbox>
                  <el-checkbox label="倾斜"></el-checkbox>
                  <el-checkbox label="人数"></el-checkbox>
                  <el-checkbox label="门锁"></el-checkbox>
                  <el-checkbox label="身份认证"></el-checkbox>
                </el-checkbox-group>
                <div class="flex" style="justify-content: right;">
                  <el-button type="primary" @click="submit">查询</el-button>
                  <el-button style="margin: 0 20px" @click="reset"
                    >重置</el-button
                  >
                  <el-button type="success" @click="reset">导出</el-button>
                </div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-table
            height="53vh"
            style="margin-top: 20px"
            align="center"
            class="table"
            :data="[{}, {}, {}]"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="80"
            ></el-table-column>
            <el-table-column align="center" label="系统时间">
              <template>2022/10/20 10:41:59</template>
            </el-table-column>
            <el-table-column align="center" label="设备编号">
              <template>SJ001</template>
            </el-table-column>
            <el-table-column align="center" label="高度(m)">
              <template>28.0</template>
            </el-table-column>
            <el-table-column align="center" label="重量(t)">
              <template>1.02</template>
            </el-table-column>
            <el-table-column align="center" label="速度(m/s)">
              <template>0.2</template>
            </el-table-column>
            <el-table-column align="center" label="速度方向">
              <template>上</template>
            </el-table-column>
            <el-table-column align="center" label="倾角1()">
              <template>0</template>
            </el-table-column>
            <el-table-column align="center" label="倾角2()">
              <template>33.3</template>
            </el-table-column>
            <el-table-column align="center" label="前门">
              <template>关闭</template>
            </el-table-column>
            <el-table-column align="center" label="后门">
              <template>关闭</template>
            </el-table-column>
            <el-table-column align="center" label="机笼">
              <template>左笼</template>
            </el-table-column>
            <el-table-column align="center" label="载重(t)">
              <template>0.765</template>
            </el-table-column>
            <el-table-column align="center" label="装载人数(个)">
              <template>0</template>
            </el-table-column>
            <el-table-column align="center" label="驾驶员">
              <template>郭帅</template>
            </el-table-column>
            <el-table-column align="center" label="身份认证匹配率">
              <template>80%</template>
            </el-table-column>
            <el-table-column align="center" label="报警类型">
              <template><div style="color:red">重量预警</div></template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mar-top20"
            align="right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
          <data-Search ref="dataSearch"></data-Search>
        </el-tab-pane>
        <el-tab-pane label="塔机" name="b">
          <el-descriptions
            class="margin-top"
            style="width: 100%"
            :column="3"
            border
          >
            <el-descriptions-item>
              <template slot="label"> 系统时间 </template>
              <el-date-picker
                v-model="startTime"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 设备型号 </template>
              <el-select placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in [{ value: 0, label: '全部' }]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 设备状态 </template>
              <el-select placeholder="请选择" clearable filterable>
                <el-option
                  v-for="item in [{ value: 0, label: '全部' }]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>


            <el-descriptions-item>
              <template slot="label"> 报警类型 </template>
              <div class="flex" style="justify-content:space-between;">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox label="正常"></el-checkbox>
                  <el-checkbox label="重量"></el-checkbox>
                  <el-checkbox label="力矩"></el-checkbox>
                  <el-checkbox label="风速"></el-checkbox>
                  <el-checkbox label="倾斜"></el-checkbox>
                  <el-checkbox label="碰撞"></el-checkbox>
                  <el-checkbox label="幅度限位"></el-checkbox>
                  <el-checkbox label="高度限位"></el-checkbox>
                  <el-checkbox label="回旋限位"></el-checkbox>
                </el-checkbox-group>
                <div class="flex" style="justify-content: right;">
                  <el-button type="primary" @click="submit">查询</el-button>
                  <el-button style="margin: 0 20px" @click="reset"
                    >重置</el-button
                  >
                  <el-button type="success" @click="reset">导出</el-button>
                </div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-table
            height="53vh"
            style="margin-top: 20px"
            align="center"
            class="table"
            :data="[{}, {}, {}]"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="80"
            ></el-table-column>
            <el-table-column align="center" label="系统时间">
              <template>2022/10/20 10:41:59</template>
            </el-table-column>
            <el-table-column align="center" label="设备编号">
              <template>SJ001</template>
            </el-table-column>
            <el-table-column align="center" label="高度(m)">
              <template>28.0</template>
            </el-table-column>
            <el-table-column align="center" label="幅度(m)">
              <template>27.5</template>
            </el-table-column>
            <el-table-column align="center" label="风速(m/s)">
              <template>0.2</template>
            </el-table-column>
            <el-table-column align="center" label="速度方向">
              <template>上</template>
            </el-table-column>
            <el-table-column align="center" label="倾角">
              <template>0</template>
            </el-table-column>
            <el-table-column align="center" label="回旋">
              <template>33.3</template>
            </el-table-column>
            <el-table-column align="center" label="力矩">
              <template>关闭</template>
            </el-table-column>
            <el-table-column align="center" label="载重(t)">
              <template>0.765</template>
            </el-table-column>
            <el-table-column align="center" label="坐标X轴">
              <template>489.9</template>
            </el-table-column>
            <el-table-column align="center" label="坐标Y轴">
              <template>47</template>
            </el-table-column>
            <el-table-column align="center" label="起重臂长">
              <template>51.2</template>
            </el-table-column>
            <el-table-column align="center" label="平衡臂长">
              <template>12.0</template>
            </el-table-column>
            <el-table-column align="center" label="塔帽高">
              <template>6.1</template>
            </el-table-column>
            <el-table-column align="center" label="塔臂高">
              <template>70.0</template>
            </el-table-column>
            <el-table-column align="center" label="操作员">
              <template>欧天赐</template>
            </el-table-column>
            <el-table-column align="center" label="身份认真匹配率">
              <template>80%</template>
            </el-table-column>
            <el-table-column align="center" label="报警类型">
              <template><div style="color:red">碰撞预警</div></template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mar-top20"
            align="right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
          <data-Search ref="dataSearch"></data-Search>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-card>
</template>
<script>
import dataSearch from "@/components/dataSearch.vue";
import {
  GetXGFormApply,
  GetFunctionTemplate,
  GetProUsersList,
} from "@/setAxios.js";
export default {
  name: "",
  props: {},
  components: { dataSearch },
  data() {
    return {
      name: "a",
      checkList: ["选中且禁用", "复选框 A"],
      dataList: [],
      userList: [],
      options: [],
      treeId: [],
      key: {},
      typeOptions: [
        {
          value: 1,
          label: "全部",
        },
        {
          value: 2,
          label: "项目建议书",
        },
        {
          value: 3,
          label: "可行性研究报告",
        },
        {
          value: 4,
          label: "项目投资估算",
        },
        {
          value: 5,
          label: "项目地质灾害评估",
        },
      ],
      typeValue: "",
      typeOptions1: [
        {
          value: "null",
          label: "全部",
        },
        {
          value: 1,
          label: "进行中",
        },
        {
          value: 2,
          label: "已通过",
        },
        {
          value: 3,
          label: "未通过",
        },
        {
          value: 4,
          label: "已撤销",
        },
      ],
      state: "null",
      userId: "",
      searchword: "",
      startTime: "",
      endTime: "",
      functionList: [
        {
          date: "111",
        },
      ],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      zNodes: [],
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.GetFunctionTemplate();
        this.GetProUsersList();
        this.dataList = [];
        this.treeId = [];
        this.total = 0;
        this.key = JSON.parse(this.$UrlEncode.decode(this.$route.query.key));
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    GetFunctionTemplate() {
      let _this = this;
      let params = {
        companyId: localStorage.pid,
        xid: localStorage.xid,
      };
      GetFunctionTemplate({ params }).then((res) => {
        if (res.Code) {
          _this.zNodes = _this
            .getTreeDate(res.Data.projectfunctiontemplates, "fctm01", "fctm03")
            .filter((el) => el.fctm01 == _this.key.type);
        }
      });
    },
    GetProUsersList() {
      let params = {
        seachword: "",
        id: localStorage.xid,
        cid: localStorage.pid,
        bid: "null",
        pageIndex: 1,
        pageSize: 999999,
      };
      GetProUsersList({ params }).then((res) => {
        this.userList = res.Data.list;
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    },
    GetXGFormApply() {
      GetXGFormApply({
        params: {
          xid: localStorage.xid,
          uid: this.userId,
          startTime: this.startTime.length ? this.startTime.join() : "",
          endTime: this.endTime.length ? this.endTime.join() : "",
          searchword: this.searchword,
          state: this.state,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          tempIds: this.treeId.map((el) => el.slice(-1).toString()).join(),
        },
      }).then((res) => {
        this.dataList = res.Data.list;
        this.total = res.Data.total;
      });
    },
    submit() {
      if (!this.treeId.length) {
        this.$message.error("请选择分类！");
        return false;
      } else {
        this.GetXGFormApply();
      }
    },
    reset() {
      this.treeId = "";
      this.userId = "";
      this.dataList = [];
      this.startTime = "";
      this.endTime = "";
      this.searchword = "";
    },
    showForm(item) {
      this.$refs.dataSearch.id = item.fmap01;
      this.$refs.dataSearch.open();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetXGFormApply();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetXGFormApply();
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped></style>
